import { Logo } from "assets";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import ArrowLeft from '../arrow_left_alt.svg';

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}

export default function Inscription(){

    useEffect(()=> {
        document.title= "Inscription - Rejoignez Wall of Share";
        const desc= "Inscrivez-vous sur Wall of Share, que vous soyez une entreprise à la recherche de talents ou un freelance en quête de missions.";
        setDescription(desc);
    },[]);
    
    return (
        <>
        <div className="w-full min-h-[100vh] bg-[#f4f4f5]">
            <Header />
            <MainContent />
        </div>
        </>
    );
};

export const Header= ({backTo= "/"}: {backTo?: string})=> {
    return<>
        <div className="w-full sm:px-[47px] px-[21px] bg-white">
            <div className="h-[75px] flex flex-row justify-between items-center max-w-[1900px] mx-auto">
                <Link to="/" className="h-max">
                    <img src={Logo} alt="Logo wall of share" className="w-[140px]" />
                </Link>
                <Link to={backTo} className="flex flex-row gap-[6.75px] group">
                    <img src={ArrowLeft} alt="Arrow Left" className="relative left-0 group-hover:left-[-4px] group-focus:left-[-4px] transition-all duration-200"/>
                    <p className="text-[20px] leading-[20px] text-primary-blue font-semibold">Retour</p>
                </Link>
            </div>
        </div>
    </>;
};

const MainContent= () => {
    return<>
        <div className="flex flex-col justify-evenly lg:gap-[87.52px] gap-[55px] max-w-[1000px] mx-auto py-[94px]">
            <div className="flex flex-col gap-[30px] lg:max-w-[826px] lg:ml-[40px] max-w-[80vw] mx-auto">
                <h1 className="lg:text-[60px] lg:leading-[72px] text-[40px] leading-[48px] text-primary-blue font-semibold">Bonjour ! Qu'est-ce qui vous amène chez <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">Wall of Share</span> ?</h1>
                <p className="lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f] font-normal font-dm-sans">Inscrivez-vous et accédez à toutes les fonctionalités de Wall of Share.</p>
            </div>
            <div className="flex md:flex-row flex-col justify-between w-full lg:gap-0 gap-[36.65px] lg:max-w-[100%] max-w-[80vw] mx-auto">
                <BigRoundCard h2="Je suis une entreprise" to="/inscription-entreprises" p="Trouvez des freelances qualifiés pour vos projets." bgIm="/inscr-images/inscription-entreprise.webp" />
                <BigRoundCard h2="Je suis un freelance" to="/inscription-freelances" p="Trouvez des missions qui valorisent vos compétences." bgIm="/inscr-images/inscription-freelance.webp" />
            </div>
            <p className="font-normal text-[20px] leading-[24px] text-primary-blue lg:text-left text-center max-w-[80vw] mx-auto md:mt-0 mt-[23.5px]">Vous avez déjà un compte ? <Link className="font-semibold underline decoration-solid" to="/connexion">Connectez-vous</Link></p>
        </div>
    </>;
};

const BigRoundCard= ({h2, p, to, bgIm}: {h2: string, p: string, to: string, bgIm: string}) => {
    return<>
        <Link to={to} className="lg:w-[453px] lg:h-[536px] w-[308px] h-[278px] lg:max-w-[unset] max-w-[80vw] mx-auto rounded-[20px] flex flex-col justify-end relative bg-norepeat bg-center bg-[length:100%] hover:bg-[length:103%] focus:bg-[length:103%] transition-all duration-300 ease-out overflow-hidden lg:px-[63px] lg:py-[42px] px-[31px] py-[25px]" style={{backgroundImage: `url("${bgIm}")`}}>
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-t from-[#000f] to-[#0000] z-1"></div>
            <h2 className="text-white lg:text-[40px] lg:leading-[48px] text-[30px] leading-[36px] font-semibold relative z-2">{h2}</h2>
            <p className="lg:text-[21px] lg:leading-[27.34px] text-[16px] leading-[20.83px] text-[#bbbbc4] font-normal font-dm-sans relative z-2">{p}</p>
        </Link>
    </>;
};